import session, { State as SessionState } from "./session";

export interface State {
  session: SessionState;
}

export default {
  session,
};
